import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import { 
  makeGetUntaggedChatItem, 
  makeGetChatActiveValue 
} from '../../../../../../data/redux/chats_details/selectors'
import { chatItemClicked } from '../../../../../../data/redux/chats_details/actions'
import { CHAT_LIST_TYPE } from '../../../../../../data/config/constants'
import { showMessage } from '../../../../../../data/config/utils'

import ConversationItem from '../../../../components/conversationitem'

class UntaggedChatItem extends React.PureComponent {
  handleChatItemClicked = () => {
    const { chat_item, active, actions, id } = this.props
    if (!active) {
      const payload = {
        sessionId: chat_item.sessionId,
        type: CHAT_LIST_TYPE.UNTAGGED_CHATS,
        id
      }
      actions.chatItemClicked(payload)
    } else
      showMessage('warning', 'chat item is already joined the chatroom')
  }

  render() {
    const { chat_item, active } = this.props
    return (
      <ConversationItem
        active={active}
        chat_item={chat_item}
        handleChatItemClicked={this.handleChatItemClicked}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getChatItem = makeGetUntaggedChatItem()
  const getChatActive = makeGetChatActiveValue()

  const mapStateToProps = (state, props) => {
    return {
      chat_item: getChatItem(state, props),
      active: getChatActive(state, props)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        chatItemClicked
      },
      dispatch),
  }
}

UntaggedChatItem.propTypes = {
  id: PropTypes.string.isRequired,
  // admin_id: PropTypes.string,
  chat_item: PropTypes.object,
  active: PropTypes.bool,
  is_chats_socket_connected: PropTypes.bool,
  actions: PropTypes.object,
}

UntaggedChatItem.defaultProps = {
  active: false,
  chat_item: {}
}

export default connect(makeMapStateToProps, mapDispatchToProps)(UntaggedChatItem)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/components/untaggedchatitem/index.js